import type { Link, Parent, Root, RootContent } from 'mdast';
import { findAndReplace } from 'mdast-util-find-and-replace';

import { isUuid, UUID_PATTERN } from '../sessions/uuid';

export const SESSION_LINK_PREFIX = '/sessions?session=';

export const sessionIdFromHref = (href: string | undefined): string | null =>
  href?.startsWith(SESSION_LINK_PREFIX)
    ? decodeURIComponent(href.slice(SESSION_LINK_PREFIX.length))
    : null;

const toLink = (id: string): Link => ({
  type: 'link',
  url: `${SESSION_LINK_PREFIX}${encodeURIComponent(id)}`,
  title: null,
  children: [{ type: 'text', value: id }],
});

// Modellen sätter ofta id:t i backticks; det blir inlineCode, som findAndReplace inte rör.
const linkCodeIds = (parent: Parent): void => {
  parent.children = parent.children.map((child): RootContent => {
    if (child.type === 'inlineCode' && isUuid(child.value)) return toLink(child.value);
    if ('children' in child) linkCodeIds(child);
    return child;
  });
};

// Modellen skriver hela session-id:t i löptext och tabeller. Länken görs här, inte av
// modellen: en markdown-länk den själv skriver kan ha kortat id:t och går inte att slå upp.
export const sessionIdLinks = () => (tree: Root) => {
  findAndReplace(tree, [new RegExp(`\\b${UUID_PATTERN}\\b`, 'gi'), toLink], {
    ignore: ['link', 'linkReference'],
  });
  linkCodeIds(tree);
};
